<template>
  <div>
    <Profile />
    <Dokumentasi />
    <!-- <Ongoing /> -->
  </div>
</template>
<script>
import Profile from "./Profile.vue";
import Dokumentasi from "./components/Dokumentasi.vue";
// import Ongoing from "./components/Ongoing.vue";

export default {
  components: {
    Profile,
    Dokumentasi,
    // Ongoing,
  },
};
</script>
